import React from "react";
import { tools } from "../../data/content";
import { CtaButton } from "../CtaButton";
export function Tools() {
  return <section className="bg-paper py-16 sm:py-20" aria-labelledby="tools-title" data-id="element-270" data-mp="2mkfmyv626irs">
      <div className="mx-auto max-w-4xl px-5" data-id="element-271" data-mp="2hj9u8xceevi9">
        <h2 id="tools-title" className="text-center font-display text-[30px] font-black leading-tight text-ink sm:text-[42px]" data-id="element-272" data-mp="2hm4eanri2eb5">
          And I'm also giving you these <em className="text-brand" data-id="element-273" data-mp="28kem3fpsnbcb">tools inside the system</em>
        </h2>

        <ul className="mt-10 overflow-hidden rounded-3xl border border-line bg-white" data-id="element-274" data-mp="23s4p5fq9hb0j">
          {tools.map(({
          icon: Icon,
          title,
          text
        }, i) => <li key={title} className={`flex gap-4 p-5 sm:p-6 ${i > 0 ? "border-t border-line" : ""}`} data-id="element-275" data-mp="1yttfb4zyv0ib" data-mpi={i}>
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-brand text-white" data-id="element-276" data-mp="1tsdv1f5m4y0z">
                <Icon className="h-6 w-6" aria-hidden="true" data-id="element-277" data-mp="1puom8e76bzdj" />
              </span>
              <div data-id="element-278" data-mp="1kvvfr5qb18mv">
                <h3 className="text-[18px] font-extrabold leading-snug text-ink" data-id="element-279" data-mp="159g81sfy7dkt">{title}</h3>
                <p className="mt-1 text-[15px] leading-relaxed text-muted sm:text-base" data-id="element-280" data-mp="157n089tlmnb8">{text}</p>
              </div>
            </li>)}
        </ul>

        <div className="mt-10 rounded-3xl bg-navy px-6 py-8 text-center text-white sm:px-10" data-id="element-281" data-mp="wa2xsxk02kz1">
          <p className="text-sm font-bold uppercase tracking-wider text-sky" data-id="element-282" data-mp="10b6bpeihm6xm">My goal is simple</p>
          <p className="mt-3 font-display text-[24px] font-bold leading-snug sm:text-3xl" data-id="element-283" data-mp="1o18zvjja6sqy">
            When a patient with a herniated disc walks into your clinic… I want you to have a framework you can refer to
            instead of starting from a blank page.
          </p>
        </div>

        <div className="mt-10" data-id="element-284" data-mp="1jxb0r8tyhhxw">
          <CtaButton label="Yes, I want the complete system" caption="Instant access · Lifetime access" data-id="element-285" data-mp="1jwj6c1c3hq97" />
        </div>
      </div>
    </section>;
}